import { render, staticRenderFns } from "./QuoteExtraData.vue?vue&type=template&id=105726d5&scoped=true&"
import script from "./QuoteExtraData.vue?vue&type=script&lang=js&"
export * from "./QuoteExtraData.vue?vue&type=script&lang=js&"
import style0 from "./QuoteExtraData.vue?vue&type=style&index=0&id=105726d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105726d5",
  null
  
)

export default component.exports